import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { ViewState } from '../Root/viewModel'

import { ATTRIBUTE_CUSTOMERID } from '../../utils/constants'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  customerNumber?: string | null

  handleNext: () => void
  handleBack: () => void
  handleFormChange: (Object) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    customerNumber: null,

    handleNext: mobx.action(() => {
      state.customAttributes.set(ATTRIBUTE_CUSTOMERID, vm.customerNumber)
      transitioner.goForward(
        state.currentNode.nextNode && state.currentNode.nextNode.id,
      )
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(ATTRIBUTE_CUSTOMERID)
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { customerNumber } = values
      vm.customerNumber = customerNumber
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
